import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import tailwindConfig from '../../tailwind.config'

gsap.registerPlugin(ScrollTrigger)

const tabletScreen = tailwindConfig.theme.screens.lg.replace('px', '')
const mobileScreen = tailwindConfig.theme.screens.md.replace('px', '')


function scrollTo(){
	// Function to handle smooth scrolling for anchor links
	function smoothScroll(target, offset) {
		const element = document.querySelector(target);
	
		if (element) {
			window.scrollTo({
				top: element.offsetTop - offset,
				behavior: 'smooth'
			});
		}
	}

	// Detect all anchor links on the page without data-scroll-to attribute
	const scrollToLinks = document.querySelectorAll('a[href^="#"]:not([data-scroll]):not([class^="magnific-"]:not([class="no-default-action"])')
	scrollToLinks.forEach(link => {
		link.setAttribute('data-scroll', 'scroll-to');
	});

	
	// Event listener for anchor links
	let anchorLinks = document.querySelectorAll( '[data-scroll=scroll-to]' )

	anchorLinks.forEach(element => {
		element.addEventListener('click', function(event) {
			const target = event.target;
		
			event.preventDefault(); // Prevent default anchor link behavior
		
			let offset = 50; // Adjust this value to set the desired offset
			if ( target.getAttribute('data-scroll-space') ){
				offset = target.getAttribute('data-scroll-space')
			}
			smoothScroll(target.getAttribute('href'), offset); // Smooth scroll to the target element with an offset
		});
	});
}

function responsiveTables(){
	if ( document.querySelectorAll('.tablepress').length > 0 ) {
		const tables = document.querySelectorAll('.tablepress');

		var wrap = function (toWrap, wrapper) {
			wrapper = wrapper || document.createElement('div');
			wrapper.classList.add('responsive-table');
			toWrap.parentNode.appendChild(wrapper);
			return wrapper.appendChild(toWrap);
		};

		[...tables].forEach((table) => {
			wrap(table);
		});
	}
	if ( document.querySelectorAll('main.main .prose table').length > 0 ) {
		const tables = document.querySelectorAll('.main.main .prose table');

		var wrap = function (toWrap, wrapper) {
			wrapper = wrapper || document.createElement('div');
			wrapper.classList.add('responsive-table');
			
			// Insert the wrapper before the toWrap element
			toWrap.parentNode.insertBefore(wrapper, toWrap);
			
			return wrapper.appendChild(toWrap);
		};

		[...tables].forEach((table) => {
			wrap(table);
		});

	}
}

function stickyOnScroll(){
	const triggers = document.querySelectorAll( '[data-js=sticky-on-scroll]' )
	
	if ( triggers.length > 0 ){
		triggers.forEach(element => {
			let pageHeight = document.body.clientHeight
			let whereNextAndFooterHeight = document.querySelector('#where-next')?.offsetHeight + document.querySelector('#site-footer')?.offsetHeight

			if ( window.innerWidth >= tabletScreen ){
				// Sticky to the top
				gsap.timeline({
					scrollTrigger: {
						trigger: element,
						pin: true,
						pinSpacing: false,
						//markers: true,
						start: 'top top',
						end: pageHeight - whereNextAndFooterHeight + 'px',
					}
				});
			} else {
				// Slide in and out
				const elementHeightStart = element.offsetHeight;
				element.style.height = ( window.innerWidth >= mobileScreen? '75px' : '65px' );

				element.addEventListener('click', function(event) {
					element.classList.toggle('open')

					if ( element.classList.contains('open') ){
						gsap.to(element, { height: elementHeightStart + 'px', duration: 0.5, ease: 'power2.out' })
					} else {
						gsap.to(element, { height: 75 + 'px', duration: 0.5, ease: 'power2.out' })
					}
				})

				// Sticky to the bottom
				element.style.position = 'fixed';
				element.style.bottom = 0
			}

		});
	}
}

function breadcrumbs(){
	// Not clickable
	const breadcrumbs = document.querySelectorAll( '.breadcrumb a' )
	if ( breadcrumbs.length > 0 ){
		breadcrumbs.forEach(element => {
			element.style.pointerEvents = 'none';
		});
	}
}

function changeLogo(){
	const siteLogo    = document.querySelector('[data-js="site-logo"]')
	const pageClasses = document.querySelector('body').classList

	// Mobile
	if ( window.innerWidth < tabletScreen ){
		if ( pageClasses.contains('page-template-landing-page') && ! document.querySelector('.marquee') ){
			siteLogo.src = siteLogo.src.replace('--white', '-colour')
		}
	} else {
		// Desktop
		if ( pageClasses.contains('page-template-landing-page') && ! document.querySelector('.marquee') ){
			siteLogo.src = siteLogo.src.replace('-colour', '--white')
		}
	}
}

export { scrollTo, responsiveTables, stickyOnScroll, breadcrumbs, changeLogo }